import * as Const from '../constants';
import State from '../interfaces/state/UsersState';

const initState: State = {
  users: [],
  isLoading: false,
  isError: false,
  type: null,
  currentUser: null,
};

export default function tab(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.USERS_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.USERS_TYPE_RECEIVE:
      return {
        ...state,
        type: action.payload,
      };

    case Const.USERS_RECEIVE:
      return {
        ...state,
        users: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.USERS_RECEIVE_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.USERS_RECEIVE_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.USERS_CURR_USER:
      return {
        ...state,
        currentUser: action.payload,
      };

    default:
      return state;
  }
}
